// src/services/adminOrders.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminOrders = () => {
  return adminApiRequest("/admin/orders");
};

export const getAdminOrderById = (id) => {
  return adminApiRequest(`/admin/orders/${id}`);
};

export const deleteAdminOrder = (id) => {
  return adminApiRequest(`/admin/orders/${id}`, {
    method: "DELETE",
  });
};

// ✅ UPDATED: now also sends extra fees (optional)
export const updateAdminOrderStatus = (
  id,
  status,
  extraFeeLabel,
  extraFeeAmount,
  adminNote,
  discount,
  discountType,
  discountInput
) => {
  return adminApiRequest(`/admin/orders/${id}/status`, {
    method: "PUT",
    body: JSON.stringify({
      status,
      extra_fee_label: extraFeeLabel,
      extra_fee_amount: extraFeeAmount,
      admin_note: adminNote,
      discount_amount: discount,
      discount_type: discountType,
      discount_input: discountInput
    }),
  });
};

export const createAdminOrder = (data) => {
  return adminApiRequest("/admin/orders", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const getPendingOrdersCount = () => {
  return adminApiRequest("/admin/orders/count/pending");
};

export const updateAdminOrderCustomer = (orderId, data) => {
  return adminApiRequest(`/admin/orders/${orderId}/customer`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAdminOrderItem = (orderId, itemId) => {
  return adminApiRequest(`/admin/orders/${orderId}/items/${itemId}`, {
    method: "DELETE",
  });
};

export const addAdminOrderItems = (orderId, items) => {
  return adminApiRequest(`/admin/orders/${orderId}/items`, {
    method: "POST",
    body: JSON.stringify({ items }),
  });
};
